import { createMuiTheme } from '@material-ui/core/styles';
import PromixaNova from './assets/fonts/proximanova_regular_macroman/proximanova-regular-webfont.woff2';

const proximaNova = {
    fontFamily: 'Proxima Nova',
    fontStyle: 'normal',
    fontDisplay: 'fallback',
    fontWeight: 400,
    src: `url(${PromixaNova}) format('woff2')`,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export const appTheme = createMuiTheme({
    typography: {
        fontFamily: 'Proxima Nova',
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [proximaNova],
            },
        },
    },
});
